import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Client } from 'models/ClientModel';
import { Statement } from 'models/StatementModel';
import AsyncSelect from "react-select/async";

const FamilyCredit: React.FC = () => {
  const width = { date: 10, form:10, sno:10, client: 20, amount: 8, adjustment: 8, gift: 8, received: 8, balance: 8, credit: 8 }
  const width2 = { date: 10, sno:10, client: 20,  comment:30, user: 11, amount: 8, credit: 8 }
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab("credit"));
  const [revCreditData, setRevCreditData] = useState<Statement[]>([]); 
  const [newCreditData, setNewCreditData] = useState<Statement[]>([]); 
  const [oldCreditData, setOldCreditData] = useState<Statement[]>([]); 
  const [newCreditTotal, setNewCreditTotal] = useState(0);
  const [oldCreditTotal, setOldCreditTotal] = useState(0);
  const [newGrandTotal, setNewGrandTotal] = useState(0);
  const [showCredit, setShowCredit] = useState<boolean>(false);

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const LocSpecial = Hooks.Privilege.LocationSpecial();
  Hooks.Privilege.HasOpen(Privilege);
  
  
  
  useEffect(() => {
    const fetchCredits = async () => {
      console.log("LocSpecial----->",LocSpecial); 
      if (keyId) {
        const enableCredit = LocSpecial.includes(Code.LocationSpecial.ENABLE_AUTOMATIC_CREDIT);
        setShowCredit(enableCredit);
        await callCreditOldList(keyId);
        if(enableCredit){
          await callCreditNewList(keyId);
        }
      }
    };

    fetchCredits();
  }, [keyId]);

  const callCreditOldList = async (clientId: string | undefined) => {
    if (!clientId) return;  
    const url = `custom/creditold/${clientId}`;
    await API.Data.List<Statement>(url, setOldCreditData, setError, setLoading);
  };

  const callCreditNewList = async (clientId: string | undefined) => {
    if (!clientId) return;  
    const url = `custom/credit/${clientId}`;
    await API.Data.List<Statement>(url, setNewCreditData, setError, setLoading);
  };
  
  useEffect(() => {
    if (!oldCreditData.length) return; 

    let total = 0;

    const updatedOldCredit = oldCreditData.map(statement => {
      const a1 = statement.statement_amount1 ?? 0;
      total += a1;
      return {
        ...statement,
        statement_amount6: parseFloat(total.toFixed(2))
      };
    });

    setOldCreditData(updatedOldCredit.reverse());
    setOldCreditTotal(parseFloat(total.toFixed(2)));

    setNewCreditTotal(parseFloat(total.toFixed(2)));
    setNewGrandTotal(parseFloat((total).toFixed(2)));

  }, [oldCreditData.length]);

  useEffect(() => {
    //console.log("newCreditData----->",newCreditData);
  }, [newCreditData]);
  

  useEffect(() => {
    if (!newCreditData.length) return; 

    let total = oldCreditTotal;
    let grand:number = 0;

    const updatedStatements = newCreditData.map(statement => {
      const payableAmount = statement.statement_amount1 ?? 0;
      const caseAmount = statement.statement_amount2 ?? 0;
      const giftAmount = statement.statement_amount3 ?? 0;
      const receiveAmount = statement.statement_amount4 ?? 0;

      let balance = 0;
      if(statement.form_id == Code.Form.Id.INVOICE){
        balance = receiveAmount < 0 ? 0 : payableAmount - (giftAmount + receiveAmount);
        //balance = receiveAmount < 0 ? 0 : payableAmount - (caseAmount + giftAmount + receiveAmount);
        const creditAdd = receiveAmount - caseAmount;
        //const creditAdd = receiveAmount - (caseAmount + giftAmount)
        total += creditAdd;
        grand += balance;
      }
      else
      {
        const creditLess = payableAmount;
        total -= creditLess
      }

      return {
        ...statement,
        statement_amount5: balance,
        statement_amount6: parseFloat(total.toFixed(2))
      };
    });

    setNewCreditData(updatedStatements.reverse());
    setNewCreditTotal(parseFloat(total.toFixed(2)));
    setNewGrandTotal(parseFloat((total + grand).toFixed(2)));
  }, [newCreditData.length]);
  

  const onRefresh = () => {
    const fetchCredits = async () => {
      if (keyId) {
        await callCreditOldList(keyId);
        await callCreditNewList(keyId);
      }
    };

    fetchCredits();
  };

  
  useEffect(() => { if(oldCreditData){ console.log("oldCreditData--------------->",oldCreditData); } }, [oldCreditData]);
  useEffect(() => { if(newCreditData){ console.log("statementData--------------->",newCreditData); } }, [newCreditData]);

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef}>
          <Button.Top formName='Wallet'/>
          {showCredit ? (
            <Control.Tab.Header titles={['History', 'Current']} info={newCreditTotal.toString()} info2={newGrandTotal.toString()} activeTab={activeTab} formName={"wallet"} setActiveTab={setActiveTab} />
          ) : (
            <Control.Tab.Header titles={['History']} info={newCreditTotal.toString()} info2={newGrandTotal.toString()} activeTab={activeTab} formName={"wallet"} setActiveTab={setActiveTab} />
          )}
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Button.Action title={"+ Credit"} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.CREDIT, Code.UrlPara.Client, keyId, Code.UrlPara.Type, 40)} animation={false} className="mr2" />
              <Button.Action title={"- Credit"} onClick={() => Form.Show.Popup(iframeRef, Code.Form.Name.CREDIT, Code.UrlPara.Client, keyId, Code.UrlPara.Type, 41)} animation={false} />
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Form.Columns values={[
                    [Title.Date, width2.date],
                    [Title.RefSno, width2.sno],
                    [Title.ClientName, width2.client],
                    [Title.Comment, width2.comment],
                    [Title.UserName, width2.user],
                    [Title.Amount, width2.amount, Code.Align.RIGHT],
                    [Title.Balance, width2.credit, Code.Align.RIGHT],
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {oldCreditData.map((statement, index) => { return (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.Item>
                        <Control.Grid.Modify path={Utility.Join.Edit(Privilege, Code.Form.Name.CREDIT, statement.statement_key)} iframeRef={iframeRef} Privilege={Privilege} />
                        <Control.Grid.Items values={[
                          [Utility.Format.DateOnly(statement.statement_date), width2.date],
                          [statement.statement_data1, width2.sno],
                          [statement.statement_data2, width2.client],
                          [statement.statement_data4, width2.comment],
                          [statement.statement_data3, width2.user],
                          [statement.statement_amount1, width2.amount, Code.Align.RIGHT],
                          [statement.statement_amount6, width2.credit, Code.Align.RIGHT],
                        ]} />
                      </Control.Form.Item>
                    </Control.Form.Index>
                  )})}
                </Control.Form.List>
              </Control.Form.Table>
            </Control.Tab.Content>

            {showCredit ? (
              <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
                <Control.Form.Table>
                  <Control.Form.Title>
                    <Control.Form.Columns values={[
                      [Title.Date, width.date],
                      [Title.Segment, width.form],
                      [Title.RefSno, width.sno],
                      [Title.ClientName, width.client],
                      [Title.Amount, width.amount, Code.Align.RIGHT],
                      [Title.Case, width.adjustment, Code.Align.RIGHT],
                      [Title.GiftCard, width.gift, Code.Align.RIGHT],
                      [Title.Received, width.received, Code.Align.RIGHT],
                      [Title.Unpaid, width.balance, Code.Align.RIGHT],
                      [Title.Balance, width.credit, Code.Align.RIGHT],
                    ]} first={2} />
                  </Control.Form.Title>
                  <Control.Form.List>
                    {newCreditData.map((statement, index) => { return (
                      <Control.Form.Index key={index} index={index}>
                        <Control.Form.Item>
                          <Control.Grid.Modify path={Utility.Join.Edit(Privilege, statement.form_id ==  Code.Form.Id.INVOICE ? Code.Form.Name.INVOICE : Code.Form.Name.PROFORMA, statement.statement_key)} iframeRef={iframeRef} Privilege={Privilege} />
                          <a className={`flcol list-col2 icon${statement.form_id}`}>&nbsp;</a>
                          <Control.Grid.Items values={[
                            [Utility.Get.FormName(statement.form_id), width.form],
                            [Utility.Format.DateOnly(statement.statement_date), width.date],
                            [statement.statement_data1, width.sno],
                            [statement.statement_data2, width.client],
                            [statement.statement_amount1, width.amount, Code.Align.RIGHT],
                            [statement.statement_amount2, width.adjustment, Code.Align.RIGHT],
                            [statement.statement_amount3, width.gift, Code.Align.RIGHT],
                            [statement.statement_amount4, width.received, Code.Align.RIGHT],
                            [statement.statement_amount5, width.balance, Code.Align.RIGHT],
                            [statement.statement_amount6, width.credit, Code.Align.RIGHT],
                          ]} />
                        </Control.Form.Item>
                      </Control.Form.Index>
                    )})}
                  </Control.Form.List>
                </Control.Form.Table>
                
              </Control.Tab.Content>
            ) : null}
          </Control.Form.Data>
        </form>
      )}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onRefresh} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default FamilyCredit;